import '~/sass/pages/cloud-sale.scss';
import { initDatas } from '@/components/cloud-sale-extent';
import '~/sass/pages/register.scss';
import '~/js/libs/youtube/lite-yt-embed.css';
import '@/libs/youtube/lite-yt-embed';

const { $ } = window;

function fancyboxSaleData() {
  const fancyboxDefaults = {
    buttons: [
      'close',
    ],
    mobile: {
      touch: true,
    },
    touch: {
      vertical: false,
      momentum: true,
    },
    toolbar: true,
    backFocus: false,
    baseClass: 'figure-slide',
    infobar: false,
    animationEffect: 'fade',
    transitionEffect: 'slide',
    // clickContent(current) {
    //   if (current.type === 'image') {
    //     return false;
    //   }
    // },
    caption() {
      return $(this).find('figcaption').html();
    },
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">'
        + '<i class="icon icon-close"></i>'
        + '</button>',
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
    },
    onInit() {
      // console.log(instance);
      if ($.fancybox.isMobile) {
        const a = $('body,html').scrollTop() * -1;
        $('body,html').css('top', a).addClass('fancybox-iosfix');
        // console.log(a)
      }
    },
    afterClose() {
      let offset;
      if ($('body,html').hasClass('fancybox-iosfix')) {
        offset = parseInt(document.body.style.top, 10);
        $('body,html').removeClass('fancybox-iosfix').css('top', '').scrollTop(offset * -1);
      }
    },
  };
  $('[data-fancybox="sale-data1"]').fancybox(fancyboxDefaults);
  $('[data-fancybox="sale-data2"]').fancybox(fancyboxDefaults);
  $('[data-fancybox="filter-data-pc"]').fancybox(fancyboxDefaults);
  $('[data-fancybox="filter-data-mobile"]').fancybox(fancyboxDefaults);
}

function showSearch() {
  $('#title-recommend').addClass('d-none');
  $('#title-count').removeClass('d-none');
  $('.show-less').addClass('d-none');
  $('.show-more').removeClass('d-none');
  $('header.section-register-subhead').addClass('border-bottom-0 pb-0');
  $('#locationSearchCloud').addClass('pt-0');
}

function hideSearch() {
  $('#title-recommend').removeClass('d-none');
  $('#title-count').addClass('d-none');
  $('.show-less').removeClass('d-none');
  $('.show-more').addClass('d-none');
  $('header.section-register-subhead').removeClass('border-bottom-0 pb-0');
  $('#locationSearchCloud').removeClass('pt-0');
}

// eslint-disable-next-line no-unused-vars
function showPopup() {
  // const menuClass = '.clouldpoup';

  // checkbox change
  $('.sale-modal-scroll-filter input').change(function checkL() {
    // 檢查group 顯示
    const groupTitle = $(this).closest('.card').find('h4');
    const groupCheckLength = $(this).closest('.collapse').find('input:checked').length;
    if (groupCheckLength > 0) {
      groupTitle.addClass('checked');
    } else {
      groupTitle.removeClass('checked');
    }

    // 檢查全部check disabled 移除
    const checkLegth = $('.sale-modal-scroll-filter input:checked').length;
    if (checkLegth > 0) {
      $('.sale-modal-scroll-filter a.remove').removeClass('disabled');
    } else {
      $('.sale-modal-scroll-filter a.remove').addClass('disabled');
    }
  });

  // 清除
  $('.sale-modal-scroll-filter a.remove').click(() => {
    $('.sale-modal-scroll-filter input:checked')
      .prop('checked', false);
    $('.sale-modal-scroll-filter .card h4').removeClass('checked');
    $('.custom-checkbox .tag').removeClass('checked');
    // isSmoke = '';
    // types = [];
  });
}

$(document).ready(() => {
  fancyboxSaleData();
  initDatas();
  $('#getGeoLocation').click(() => {
    showSearch();
  });
  // $('#city, #zone').change(() => {
  //   showSearch();
  // });
  // $('.pop-up[data-pop=filter] .save').click(() => {
  //   if ($('.btn[data-btn=filter]').hasClass('checked')) {
  //     showSearch();
  //   }
  // });
  $('#reSearch').click(() => {
    hideSearch();
  });

  $('#city').change(() => {
    $('#zone').prop('disabled', false);
  });

  // yt
  $('.lty-playbtn').trigger('click');

  // $('body').on('click', '.sale-share-p, .sale-share-m', function click() {
  //   const $this = $(this);
  //   $this.closest('.sale-modal').find('.sale-share-code , .qrcode-image').show();
  //   if ($(this).hasClass('sale-share-p') === false) {
  //     return;
  //   }
  //   // const cloudName = $this.closest('.sale-modal').attr('name');
  //   const qrcode = $this.closest('.sale-modal').find('.qrcode-image');
  //   qrcode.attr('src', '/public/mock/homepage/my-toyota-app-qrcode.png');
  // });

  // $('body').on('click', '.sale-share-code .close-button', () => {
  //   $('.sale-share-code').hide();
  // });
});

/**
 * @description 顯示/隱藏 scroll 提示
 */
function handleScrollHint($this) {
  const newScrollTop = $this.scrollTop();
  const scrollHint = $this.find('.scroll-hint');
  if (newScrollTop > 30) {
    scrollHint.addClass('hide');
  } else {
    scrollHint.removeClass('hide');
  }
}

/**
 * @description 顯示/隱藏 modal上方tab
 */
let oldScrollTop = 0;
function handleTabShow($this) {
  const newScrollTop = $this.scrollTop();
  const tab = $this.find('.sale-tabs');
  const spacer = $this.find('.spacer');

  const contentHeight = $this.find('.tab-content').height();
  const thisHeight = $this.height();
  if (newScrollTop + thisHeight + 50 > contentHeight) { // 處理 safari 滑到底會回彈
    return;
  }
  if (oldScrollTop < newScrollTop && oldScrollTop > 0) { // 往下滑
    tab.css({ 'margin-top': '-2.5rem' });
    spacer.css({ 'margin-top': '-2.5rem' });
  } else { // 往上
    tab.css({ 'margin-top': '0' });
    spacer.css({ 'margin-top': '0' });
  }
  oldScrollTop = newScrollTop;
}
// 無法使用body綁定，故放到cloud-sale-extent setHtml 內建置完html 後綁定
$('.sale-modal-scroll').on('scroll', function handelModalScroll() {
  handleScrollHint($(this));
  handleTabShow($(this));
});

/**
 * @description 點擊modal的scroll往下滑
 */
function handleModalScrollClick($this) {
  const imageHeight = $this.siblings('.tab-container').find('.sale-modal-img').height();
  const pane = $this.parents('.sale-modal-scroll');
  pane.animate({
    // scrollTop: 0,
    scrollTop: imageHeight ? imageHeight - 80 : 120,
  }, 800);
}
// body綁定
$('body').on('click', '.scroll-hint', function test() {
  handleModalScrollClick($(this));
});
